import { referrerDetailSearchSchema } from './referrerDetailSearchSchema';
import type z from '@/lib/zod';
import { commonSearchSchema } from './commonSearchSchema';
import { optionalSearchString } from './search-param-schemas';

/** «I miei agenti»: ricerca, ordinamento e il tab di stato (`subTab`). */
export const agentsSearchSchema = commonSearchSchema.extend({
  subTab: optionalSearchString(),
  ...referrerDetailSearchSchema.shape,
});

export type AgentsSearch = z.output<typeof agentsSearchSchema>;
